import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './CtaPanelRow.scss';


const propTypes = {
    panel: PropTypes.object
};



export default class CtaPanel extends React.Component{
    constructor (props) {
        super(props);
    }

    render() {
        const{panel} = this.props;
        const{icon, ctaLabel,  ctaRoute, count, additionalInfo, myClasses } = panel;

        //console.log('my class', myClasses);
       // console.log('mlabel', ctaLabel);

        return(

            <NavLink to={ctaRoute} className={ `panel--holder ${myClasses}`}>
                <h2 className='cta--icon'><i className={icon}></i></h2>
                <div className='cta-count'>{count}</div>
                <h2 className='cta--label'>{ctaLabel}</h2>
                <h2 className='cta--label'>{additionalInfo}</h2>
            </NavLink>
        )
    }
}

CtaPanel.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/CtaPanelRow/CtaPanel.js